const $doc = $(document);

function checkEmailMatch() {
  const errorClass = 'form__row--error';
  const $errorMsg = $('.form__row--error-message');
  const $emailRows = $('#create_customer .form__row').has('input[type="email"]');
  let email = $('#field-email').val();
  let confirmEmail = $('#field-verify').val();

  if (email !== '' && confirmEmail !== '') {
    if (email != confirmEmail) {
      $emailRows.addClass(errorClass);

      $errorMsg.show();
    } else {
      $emailRows.removeClass(errorClass);

      $errorMsg.hide();
    }
  }
}

$doc.on('keyup', function() {
  if ($('#create_customer').length) {
    checkEmailMatch();
  }
});

$doc.on('submit', '.section-login form', function() {
  $(this)
    .find('.btn')
    .css('font-size', 0)
    .children('i')
    .removeClass('hidden');
});



// WEBPACK FOOTER //
// ../assets/js/register.js